import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';

import { ReadInBrowser as ReadInBrowserIcon, ExternalArrow } from '@bibliocommons/deprecated-base-icons';
import { Link } from '@bibliocommons/base-links';

import { sendEContentAction, ECONTENT_ACTIONS } from 'app/helpers/econtent/nativeEContentBridge';
import './CheckedOutReadingLinks.scss';

export default class ThirdPartyReaderLink extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    // Inside the native app (eContent capability), hand "Open in third-party reader" to the
    // native eReader instead of opening the third-party web reader. Otherwise fall through to
    // the existing href behavior.
    const { metadataId, format, title } = this.props;
    const handledByNative = sendEContentAction(ECONTENT_ACTIONS.OPEN, metadataId, { format, title });
    if (handledByNative && event && typeof event.preventDefault === 'function') {
      event.preventDefault();
    }
  }

  render() {
    const { className, withIcons } = this.props;

    return (
      <Link
        target="_blank"
        href={this.props.thirdPartyReaderUrl}
        className={cn('cp-third-party-reader-link', className)}
        dataKey="link_thirdparty_reader"
        handleClick={this.handleClick}
        screenReaderText={<FormattedMessage id="open_in_third_party_reader" />}
      >
        {withIcons && <ReadInBrowserIcon />}
        <span aria-hidden>
          <FormattedMessage id="open_in_third_party_reader" />
        </span>
        <ExternalArrow />
      </Link>
    );
  }
}

ThirdPartyReaderLink.propTypes = {
  thirdPartyReaderUrl: PropTypes.string,
  metadataId: PropTypes.string,
  format: PropTypes.string,
  title: PropTypes.string,
  withIcons: PropTypes.bool,
  className: PropTypes.string
};
